import { AbstractModel } from '@/models/abstractModel';
import type { INotificationApi } from '@/types';
import { Locale, NotificationType } from '@/constants';

export class NotificationItem extends AbstractModel {
    public id: number;
    public createdAt: string;
    public typeId: NotificationType;
    public textEn: string;
    public textPt: string;
    public isViewed: 0 | 1;
    public isDismissed: 0 | 1;

    constructor(data: INotificationApi) {
        super();
        this.id = data.id;
        this.createdAt = data.created_at;
        this.typeId = data.type_id;
        this.textEn = data.text_en;
        this.textPt = data.text_pt;
        this.isViewed = data.is_viewed;
        this.isDismissed = data.is_dismissed;
    }

    get text(): string {
        let text = this.locale === Locale.Portuguese ? this.textPt : this.textEn;
        return text.replace(/<p.*?>/gi, '').replace(/<\/p>/gi, '');
    }

    get icon(): string {
        switch (this.typeId) {
            case NotificationType.Info:
                return mdiInformationOutline;
            case NotificationType.Warning:
                return mdiAlertOutline;
            case NotificationType.Error:
                return mdiAlertOctagonOutline;
            default:
                return '';
        }
    }
}
